module.exports = __webpack_public_path__ + "static/media/SupplyChainManagement.beac1961.pdf";